import {useEffect, useRef, useState} from "react";

import { calculateIndicatorPosition } from "../utils";

const useCurrentTime = (timeSlotHeight: number, offsetStartTime = 0): number => {
    const [currentTime, setCurrentTime] = useState(
        calculateIndicatorPosition(new Date(), timeSlotHeight, offsetStartTime)
    );
    const timeSlotHeightRef = useRef(timeSlotHeight);

    useEffect(() => {
        timeSlotHeightRef.current = timeSlotHeight; // Update ref with latest value
    }, [timeSlotHeight]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(calculateIndicatorPosition(new Date(), timeSlotHeight, offsetStartTime));
        }, 60000); // Update every minute
        return () => clearInterval(interval); // Cleanup
    }, [timeSlotHeight, offsetStartTime]);

    return currentTime;
};

export default useCurrentTime;